import { render } from "./AppointmentAsProfessional.vue?vue&type=template&id=75ce3f13&scoped=true"
import script from "./AppointmentAsProfessional.vue?vue&type=script&lang=js"
export * from "./AppointmentAsProfessional.vue?vue&type=script&lang=js"

import "./AppointmentAsProfessional.vue?vue&type=style&index=0&id=75ce3f13&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75ce3f13"]])

export default __exports__